import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppRouter } from './router';
import { ToastProvider } from '@/components/ui';
import { TrainingRequestPanelPortal } from '@/components/training-request/TrainingRequestPanelPortal';
import { DocumentA11ySync } from '@/components/accessibility/DocumentA11ySync';
import { LyrraAccessPadIndicator } from '@/components/accessibility/LyrraAccessPadIndicator';
import { GlobalMagnifierProvider } from '@/components/accessibility/GlobalContentMagnifier';
import { useAuthStore } from '@/stores/auth.store';
import { OfflineStatusBanner } from '@/components/offline/OfflineStatusBanner';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return (
    <QueryClientProvider client={queryClient}>
      <DocumentA11ySync />
      <LyrraAccessPadIndicator />
      <ToastProvider>
        {user && <TrainingRequestPanelPortal />}
        <GlobalMagnifierProvider>
          <AppRouter />
        </GlobalMagnifierProvider>
        <OfflineStatusBanner enabled={isAuthenticated} />
      </ToastProvider>
    </QueryClientProvider>
  );
}

export default App;
